import { Button, Icon } from '@pms-digital/design-system';

export interface NotesViewEmptyStateProps {
  /**
   * `none`: the matrix has no discussion at all; `filtered`: some exist but the
   * filters let none through; `all-resolved`: every one is resolved and only the
   * open ones are listed.
   */
  kind: 'none' | 'filtered' | 'all-resolved';
  /** « Réinitialiser les filtres ». */
  onReset: () => void;
  /** « Voir les résolues ». */
  onShowResolved: () => void;
}

/** The empty states of the Notes view (planche 16). */
export function NotesViewEmptyState({ kind, onReset, onShowResolved }: NotesViewEmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-lg px-6 py-8 text-center">
      <Icon name="chat_bubble" size={24} />
      {kind === 'none' && (
        <>
          <p className="font-semibold text-small">Aucune note sur cette matrice</p>
          <p className="max-w-sm text-caption text-gray-600">
            Survolez une case et cliquez sa bulle « + », ou passez par son menu « ⋯ ».
          </p>
        </>
      )}
      {kind === 'filtered' && (
        <>
          <p className="font-semibold text-small">Aucune note ne correspond à ces filtres</p>
          <Button type="button" variant="primary" size="sm" onClick={onReset}>
            Réinitialiser les filtres
          </Button>
        </>
      )}
      {kind === 'all-resolved' && (
        <>
          <p className="font-semibold text-small">Toutes les discussions sont résolues</p>
          <Button type="button" variant="primary" size="sm" onClick={onShowResolved}>
            Voir les résolues
          </Button>
        </>
      )}
    </div>
  );
}
